import { createSlice } from '@reduxjs/toolkit';
import {
    getInvestor,
    getAllCountries,
    getAllOrganisationProfiles,
    getOrganizationDetails,
    getBuyerStats,
    getSupplierStats,
    getPricingConfigurator,
    getPastPricingConfigurator,
    getSupplierPortsProducts,
} from '../actions/userManagementApi';

export const userManagementSlice = createSlice({
    name: 'userMang',
    initialState: {
        isLoading: false,
        error: null,
        getInvestors: [],
        countryList: [],
        allOrganisationProfiles: [],
        organizationDetails: {},
        buyerStats: {},
        supplierStats: {},
        pricingConfigurator: null,
        pastPricingConfigurator:null,
        isPortsProductsLoading: false,
        portsProductsList: [],
        portsProductsCursor: 0,
        portsProductsHas_Next: false,
        supOrgUlid: '',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getInvestor.pending, (state) => {
                state.isLoading = true;
                state.getInvestors = [];
            })
            .addCase(getInvestor.fulfilled, (state, action) => {
                state.isLoading = false;
                state.getInvestors = action.payload;
            })
            .addCase(getInvestor.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
                state.getInvestors = [];
            })
            .addCase(getAllCountries.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getAllCountries.fulfilled, (state, action) => {
                state.isLoading = false;
                const transformedOptions = action.payload.map((item) => ({
                    name: item.country_name,
                    value: item.ulid,
                }));
                state.countryList = transformedOptions;
            })
            .addCase(getAllCountries.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })
            .addCase(getAllOrganisationProfiles.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getAllOrganisationProfiles.fulfilled, (state, action) => {
                state.isLoading = false;
                state.allOrganisationProfiles = action.payload;
            })
            .addCase(getAllOrganisationProfiles.rejected, (state, action) => {
                state.isLoading = false;
            })
            .addCase(getOrganizationDetails.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getOrganizationDetails.fulfilled, (state, action) => {
                state.isLoading = false;
                state.organizationDetails = action.payload;
            })
            .addCase(getOrganizationDetails.rejected, (state, action) => {
                state.isLoading = false;
                state.organizationDetails = {};
            })
            .addCase(getBuyerStats.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getBuyerStats.fulfilled, (state, action) => {
                state.isLoading = false;
                state.buyerStats = action.payload;
            })
            .addCase(getBuyerStats.rejected, (state, action) => {
                state.isLoading = false;
            })
            .addCase(getSupplierStats.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getSupplierStats.fulfilled, (state, action) => {
                state.isLoading = false;
                state.supplierStats = action.payload;
            })
            .addCase(getSupplierStats.rejected, (state, action) => {
                state.isLoading = false;
            })
            .addCase(getPricingConfigurator.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getPricingConfigurator.fulfilled, (state, action) => {
                state.isLoading = false;
                state.pricingConfigurator = action.payload;
            })
            .addCase(getPricingConfigurator.rejected, (state, action) => {
                state.isLoading = false;
            })
            .addCase(getPastPricingConfigurator.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getPastPricingConfigurator.fulfilled, (state, action) => {
                state.isLoading = false;
                state.pastPricingConfigurator = action.payload;
            })
            .addCase(getPastPricingConfigurator.rejected, (state, action) => {
                state.isLoading = false;
            })
            .addCase(getSupplierPortsProducts.pending, (state, action) => {
                if (state.supOrgUlid !== action.meta.arg.organization_ulid) {
                    state.portsProductsList = [];
                }
                state.isPortsProductsLoading = true;
            })
            .addCase(getSupplierPortsProducts.fulfilled, (state, action) => {
                const existingListSet = new Set((state.portsProductsList || []).map((_a) => _a.ulid));
                const newList = (action.payload.payload || []).filter((_b) => !existingListSet.has(_b.ulid));

                state.portsProductsList = [...state.portsProductsList, ...newList];
                state.isPortsProductsLoading = false;
                state.portsProductsCursor = action.payload.next_cursor;
                state.portsProductsHas_Next = action.payload.has_next;
                state.supOrgUlid = action.payload.supOrgUlid;
            })
            .addCase(getSupplierPortsProducts.rejected, (state, action) => {
                state.isPortsProductsLoading = false;
            });
    },
});

export default userManagementSlice.reducer;
